if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) {
          return;
        }
        
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // console.log(this,'thsisisi');
        const presIcmgOutput = this.querySelector('#presc-img-output');
        console.log(presIcmgOutput,'kdkdkdk');
        
        if(presIcmgOutput){
          const upPrescOutputImg = presIcmgOutput.querySelector('.up-presc__output-img');
          if(!upPrescOutputImg){
            this.querySelector('.upload-prescription-err-mssg')?.classList?.remove('hidden')
            return;
          }
        }
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // code for vet-app

        const savedDoctorId = localStorage.getItem('doctor_id');
        if(savedDoctorId){
            // Add your custom property here
            formData.append('properties[doctorId]', savedDoctorId);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        window.dispatchEvent(
          new CustomEvent('animeal:cart:request-start', {
            detail: {
              source: 'product-form',
              variantId: Number(formData.get('id')),
              quantity: Number(formData.get('quantity') || 1),
            },
          })
        );

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Shopify can add fewer than requested (someone else just
              // bought the last few units) and still respond with
              // status 422 + "Only N items were added to your cart due
              // to availability." — the add DID succeed for N, so this
              // must not fall into the sold-out/failure branch below,
              // which shows no error text at all when the redesigned
              // button has no ".sold-out-message" span, and used to
              // skip refreshing the cart entirely, leaving the drawer/
              // icon stale until a full page reload.
              const partialMessage = response.description || response.message || '';
              const partiallyAdded = response.status === 422 && /were added/i.test(partialMessage);

              if (partiallyAdded) {
                this.error = false;
                document.dispatchEvent(
                  new CustomEvent('cart:partial-add', {
                    bubbles: true,
                    detail: { message: partialMessage, variantId: formData.get('id') },
                  })
                );

                fetch(`${routes.cart_url}.js`, { credentials: 'same-origin', cache: 'no-store' })
                  .then((r) => r.json())
                  .then((cartData) => {
                    if (window.customATCManager && typeof window.customATCManager.refreshCartDrawer === 'function') {
                      window.customATCManager.refreshCartDrawer(false);
                    }
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      cartData: cartData,
                    });
                    window.dispatchEvent(
                      new CustomEvent('animeal:cart:changed', {
                        detail: {
                          source: 'product-form',
                          cart: cartData,
                          variantId: Number(formData.get('id')),
                          quantity: Number(formData.get('quantity') || 1),
                        },
                      })
                    );
                  });
                return;
              }

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            window.dispatchEvent(
              new CustomEvent('animeal:cart:changed', {
                detail: {
                  source: 'product-form',
                  cart: response,
                  variantId: Number(formData.get('id')),
                  quantity: Number(formData.get('quantity') || 1),
                },
              })
            );
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // On the product page itself, don't pop the cart drawer open —
              // just keep the cart icon bubble (and the drawer contents
              // underneath) up to date, same as adding from a product card.
              const isProductPage = this.closest('.new-prd-design-wrapper');
              this.cart.renderContents(response, !isProductPage);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // console.info('Product Added :- ', this.closest('product-form').querySelector('.custom__animal_sound audio'));
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            // Animal Sound When Product Added to Cart
            // this.closest('product-form').querySelector('.custom__animal_sound audio')?.play();
            const animalSound = this.closest('product-form').querySelector('.custom__animal_sound audio');
            if(animalSound?.classList?.contains("itsAnCatPrd")){
              console.log("prodcut from, animal voice called...")
              document.querySelector(".custom__animal_sound_thm audio")?.play().catch(() => {});
            } 

            window.dispatchEvent(
              new CustomEvent('animeal:cart:request-end', {
                detail: {
                  source: 'product-form',
                  variantId: Number(formData.get('id')),
                },
              })
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
